export default defineNuxtPlugin(() => {
    interface UtmData {
        source?: string;
        medium?: string;
        campaign?: string;
        term?: string;
        content?: string;
        timestamp: number;
    }

    const STORAGE_KEY = 'utm_data';

    const getUtmParams = (): Partial<UtmData> => {
        const params: Partial<UtmData> = {};
        const urlParams = new URLSearchParams(window.location.search);

        const utmParams = {
            source: 'utm_source',
            medium: 'utm_medium',
            campaign: 'utm_campaign',
            term: 'utm_term',
            content: 'utm_content'
        };

        Object.entries(utmParams).forEach(([key, param]) => {
            const value = urlParams.get(param);
            if (value) {
                type UtmKey = keyof UtmData;
                params[key as UtmKey] = value as any;
            }
        });

        return params;
    };

    const saveUtmData = (): void => {
        try {
            const utmParams = getUtmParams();

            if (Object.keys(utmParams).length > 0) {
                const utmData: UtmData = {
                    ...utmParams,
                    timestamp: Date.now()
                };

                localStorage.setItem(STORAGE_KEY, JSON.stringify(utmData));
            }
        } catch (error) {
            console.error('Ошибка при сохранении UTM данных:', error);
        }
    };

    const getUtmData = (): UtmData | null => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored) {
                return JSON.parse(stored);
            }
        } catch (error) {
            console.error('Ошибка при получении UTM данных:', error);
        }
        return null;
    };

    const clearUtmData = (): void => {
        try {
            localStorage.removeItem(STORAGE_KEY);
        } catch (error) {
            console.error('Ошибка при очистке UTM данных:', error);
        }
    };

    if (process.client) {
        saveUtmData();
    }

    return {
        provide: {
            utm: {
                getData: getUtmData,
                clearData: clearUtmData,
                saveData: saveUtmData
            }
        }
    };
});